import {registerReactPartial} from '@github-ui/react-core/register-partial'
import {CopilotCodeChatPartial} from './CopilotCodeChatPartial'

import './CopilotDiffEntryElement'

registerReactPartial('copilot-code-chat', {
  Component: CopilotCodeChatPartial,
})
